// extracted by mini-css-extract-plugin
module.exports = {"ol":"styles_ol__QOf0b","ul":"styles_ul__Ep1_0","listStyle":"styles_listStyle__v1y9I","bulletPoint":"styles_bulletPoint__JElC3"};